// src/components/SlideInModal.jsx

import React from "react";
import logo from "../../assets/icons/cancel.png"; // adjust path accordingly

const Modal = ({ isOpen, onClose, children, width = '50%' }) => {
  if (!isOpen) return null;

  return (
    <div
      className={`fixed right-0 top-0 h-full w-[90%] md:w-auto bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-[1050] py-4 ${isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      style={{ width: '90%', maxWidth: width,zIndex: '1000' }}
    >
      {/* Close Button */}
      <div className="relative p-0">
        <button
          className={`!absolute -left-16 top-4 bg-white rounded-l-full h-10 w-16 shadow-lg transition-transform duration-300 ${isOpen ? "translate-x-0" : "translate-x-40"
            }`}
          onClick={onClose}
        >
          <img src={logo} alt="close" className="h-6 w-6 m-auto" />
        </button>
      </div>

      {/* Content goes here */}
      <div className="px-5 h-full overflow-y-auto pb-28" style={{zIndex:'1000'}}>{children}</div>
    </div>
  );
};

export default Modal;
